import { render } from "./News.vue?vue&type=template&id=a5355d76&scoped=true&ts=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=a5355d76&lang=scss&scoped=true"

import exportComponent from "C:\\work\\h5\\lddz\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5355d76"]])

export default __exports__